import { type PageContainerProps } from '@ant-design/pro-layout'
import { Breadcrumb, BreadcrumbProps } from 'antd'
import BreadcrumbItem from 'antd/lib/breadcrumb/BreadcrumbItem'
import dynamic from 'next/dynamic'
import Link from 'next/link'
import { FC } from 'react'

const BasePageContainer = dynamic(
  async () => (await import('@ant-design/pro-layout')).PageContainer,
  { ssr: false }
)

const defaultBreadcrumbRender: PageContainerProps['breadcrumbRender'] = ({
  breadcrumb,
}) => (
  <Breadcrumb>
    {(breadcrumb as BreadcrumbProps).items?.map((route, index, items) => (
      <BreadcrumbItem key={route.path}>
        {index === items.length - 1 ? (
          route.breadcrumbName
        ) : (
          <Link href={route.path ?? ''}>{route.breadcrumbName}</Link>
        )}
      </BreadcrumbItem>
    ))}
  </Breadcrumb>
)

export const PageContainer: FC<PageContainerProps> = (props) => (
  <BasePageContainer breadcrumbRender={defaultBreadcrumbRender} {...props} />
)
